var MyLocation = function(options) {

  var self = this;

  self.data = {};

  self.settings = {
    getUrl: '/api/get_my_location',
    setUrl: '/api/set_my_location?id=',
    searchUrl: '/api/search_locations',
    template: '#my-location__template',
    selector: '.js-my-location',
    button: '.js-my-location__open-button',
    details: '.js-my-location-details',
    prompt: '.js-location-prompt',
  };

  function addEvents() {

    var $button = $('.js-my-location__open-button');
    var $details = $(self.settings.details);
    var $prompt = $(self.settings.prompt);

    $button.on('click', function(event) {
      if($details.hasClass('is-visible')) {
        closeDetails();
      } else {
        openDetails();
      }
    })

    $(document).on('click', function(e){
      if ($details.hasClass('is-visible')) {
        if ($(e.target).parents().filter($details).length === 0 && // click target is not inside $details
            !$(e.target).is($details) && // click target is not the $details element
            $(e.target).parents().filter($button).length === 0 && // click target is not inside $button
            !$(e.target).is($button) // click target is not the $button element
        ) {
          closeDetails();
        }
      }
    });

    $prompt.on('click', handlePromptClick);

    $(document).on('keydown', handleKeyPress);
  }

  function registerHelpers() {

  }

  function handleKeyPress(event) {
    var $details = $(self.settings.details);
    var keys = {
      8: 'backspace',
      13: 'enter',
      27: 'esc',
      37: 'left',
      39: 'right',

    }
    switch (keys[event.keyCode]) {
      case 'esc':
      case 'backspace':
        if ($details.hasClass('is-visible')) {
          closeDetails();
        }
        break;
      default:
        break;
    }
  }

  function openDetails() {
    var $button = $(self.settings.button);
    var $details = $(self.settings.details);
    $button.addClass('is-open');
    $details.addClass('is-visible');
    $button.attr('aria-expanded', 'true');
    $details.focus();
  }

  function closeDetails() {
    var $button = $(self.settings.button);
    var $details = $(self.settings.details);
    $button.removeClass('is-open');
    $details.removeClass('is-visible');
    $button.attr('aria-expanded', 'false');
    $button.focus();
  }

  function nearbyLocationCard(data){
    if (document.getElementById("nearbyLocationCard")) {
      const locationData = data.location
      console.log(locationData)
      // document.getElementById('nearbyLocationData').dataset.location = JSON.stringify(data.nearby)
      const template = `<div
      id="location-result"
      data-id="${ locationData.id }"
      class="location-result location-result--list js-location-result"
      aria-label="Contact Details for ${ locationData.name }"
      style="background:white;border-radius:12px;box-shadow:1px 2px 3px 1px gainsboro;margin-top:40px;"

    >
      <div class="location-result__container">
        <div class="location-result__pre">
          <button
            class="js-favorite-button location-result__fav-button c-fav-button${ (location.favorite) ? 'is-active' : ''}"
          >
            <span class="c-fav-button__inactive">Make Favorite</span>
            <span class="c-fav-button__active">Favorite</span>
          </button>
          ${ (locationData.ufc) ? '<div class="location-result__ufc"><span class="location-result__ufc-text">Showing </span><img src="/assets/images/ufc_logo.svg" alt="UFC" class="location-result__ufc-icon"></div>' : '' }
        </div>
        <div class="location-result__body">
          <div class="location-result__meta">
            <a
              href="${ location.slug }"
              aria-label="Location Details for ${ locationData.name }"
            >
              <h3 class="location-result__name js-location-name">testing
                ${ locationData.name }
              </h3>
            </a>
            <span class="location-result__direction"></span>
            <!-- <span class="location-result__open-status"></span> -->
            <span class="location-result__open-status"
              >${location.hoursText ? location.hoursText : location.hoursString}</span
            >
            <address class="location-result__address">
              <span class="location-result__address-line-1"
                >${ locationData.address['line-1'] }</span
              >
              <span class="location-result__address-line-2"
                >${ locationData.address['line-2'] }</span
              >
            </address>
            <a
              href="https://www.google.com/maps/dir//Hooters,${ locationData.address['line-1'] },${ locationData.address['line-2'] }"
              class="location-result__directions-link"
              >Get Directions</a
            >
            <a href="tel:${ locationData.phone }" class="location-result__phone"
              >${ locationData.phone }</a
            >
          </div>
          <ul class="location-result__links-list">
            <li class="location-result__link-item">
              <a
                href="${ locationData.detailsUrl }"
                class="location-result__link"
                aria-label="Store Details for ${ locationData.name }"
                >Store Details</a
              >
            </li>
            <li class="location-result__link-item">
              <a
                href="${ locationData.orderingUrl }"
                class="location-result__link location-result__link--alt"
                aria-label="Order Online for ${ locationData.name }"
                >Order Online</a
              >
            </li>
            <li class="location-result__link-item">
              <a href="${ locationData.cateringUrl}" class="location-result__link location-result__link--white" aria-label="Order Catering for ${ locationData.name }">Order Catering</a>
            </li>
            <li class="location-result__link-item">
              <a href="${ locationData.reservationUrl}" class="location-result__link location-result__link" aria-label="Make a Reservation at ${ locationData.name }">Reserve a Table</a>
            </li>
          </ul>
        </div>
        <div class="location-result__extras">
          <a
            href="https://www.google.com/maps/dir//Hooters,${ locationData.address['line-1'] },${ locationData.address['line-2'] }"
            class="location-result__map js-result-map"
            data-bg="${ locationData.maps.default }"
            data-min-size="850"
            style="
            background-image: url('${ locationData.maps.default }');
          "
            >Map of Hooters of ${ locationData.name }</a
          >
        </div>
      </div>
    </div>
  `
    document.getElementById('nearbyLocationCard').innerHTML = template
    }

  }

  //Update Header Order Button URL if Location Set
  function orderButtonUpdate(data) {
    
    if (data && data.location.id) {
      self.data = data;
    }

    var outputData = data ? data : self.data;
    const location = outputData.location;
    const orderButton = document.querySelectorAll('.header-button--order-online');
    const orderLocation = document.getElementById('popupOrderLocation')
    const defaultOrderButtonWrapper = document.querySelector('.order-popup__other-button');
    const defaultOrderButton = document.querySelector('.order-popup__button');
   
    if (orderButton && location && orderLocation) {

      //Updates Order Button URL in Header
      orderButton.forEach((orderButton) => {
        
        //Setting up alternate behavior if a location does not have an order URL entered
        if (location.orderingUrl) {
          //Sets Popover Location Display Name & URL     
          orderLocation.innerHTML = location.name;           
          orderButton.setAttribute('href', location.orderingUrl)          
          //Makes Default Order Button Visible if Invidivual Location Set      
          defaultOrderButtonWrapper.classList.add('visible');
          defaultOrderButton.addEventListener("click", () => {
            window.location = 'https://order.hooters.com'; //Resets link after URL update so proceed() takes place and resets timer
          })
        } else {
          //Reset For Null Location
          orderLocation.innerHTML = 'Hooters';
          orderButton.setAttribute('href', 'https://order.hooters.com')
          defaultOrderButtonWrapper.classList.remove('visible');   
        }

       }) 

    }

  }

  function output(data) {
    if (data && data.location.id) {
      self.data = data;
    }
    var outputData = data ? data : self.data;
    var $component = $(self.settings.selector);
    $component.removeClass('is-loading');
    $component.addClass('is-loaded');
    const location = outputData.location
    const template = `<div class="my-location"><a href="#" role="button" class="my-location__open-button js-my-location__open-button" aria-haspopup="true" aria-expanded="false" aria-controls="my-location-details" aria-label="Show Store Details for ${location.name}"><span class="my-location__title">Your Hooters</span><span class="my-location__name">${location.name}</span></a><div class="my-location__meta"><a href="/locations/?address=${location.zip}" class="my-location__change-link">More Locations</a></div>
  </div>
  <div id="my-location-details" class="my-location-details js-my-location-details"
    aria-label="Contact Details for ${location.name}" tabindex="-1">
  <div class="my-location-details__pre">
    <button tabindex="-1" class="my-location-details__fav-button c-fav-button is-active">Favorite</button>
    ${(location.ufc) ? '<div class="my-location-details__ufc"><span class="my-location-details__ufc-text">Showing </span><img src="/assets/images/ufc_logo.svg" alt="UFC" class="my-location-details__ufc-icon"></div>' : ''}
  </div>
  <h3 class="my-location-details__name">${location.name}</h3>
  <span class="my-location-details__direction">${(location.direction) ? location.direction : ''}</span>
  <span class="my-location-details__open-status">${location.hoursText ? location.hoursText : location.hoursString}</span>
  <address class="my-location-details__address">
    <span class="my-location-details__address-line-1">${(location.address.line-1) ? location.address.line-1 : ''}</span>
    <span class="my-location-details__address-line-2">${(location.address.line-2) ? location.address.line-2 : ''}</span>
  </address>
  <a href="https://www.google.com/maps/dir//Hooters,${location.address.line-1},${location.address.line-2}" class="my-location-details__directions-link">Get Directions</a>
  <a href="tel:${location.phone}" class="my-location-details__phone">${location.phone}</a>
  <ul class="my-location-details__links-list">
    <li class="my-location-details__link-item">
      <a href="${location.detailsUrl}" class="my-location-details__link"
        aria-label="Store Details for ${location.name}">Store Details</a>
    </li>
    <li class="my-location-details__link-item">
      <a href="${location.orderingUrl ? location.orderingUrl : 'https://order.hooters.com'}" class="my-location-details__link"
        aria-label="Order Online for ${location.name}">Order Online</a>
    </li>
  </ul>
</div>`
    var $nearbyResults = document.querySelectorAll('.location-result__map.js-result-map');
    $nearbyResults.forEach(map => map.style.backgroundImage = `url(${map.dataset.bg})`);
    $component.html(template);
    addEvents();
  };

  function save(id, expiry) {
    var days = Number.parseInt(expiry) || 7;
    Cookies.set('location', id, { expires: days, path: '/', domain: window.location.hostname });
  };

  function initPrompt() {
    if (!Cookies.get('geolocated') && !Cookies.get('geoignored')) {
      showPrompt();
      self.ignoreTimeout = setTimeout(function dismissLocationPrompt() {
        Cookies.set('geoignored', 'true', { expires: 1, path: '/', domain: window.location.hostname });
      }, 5000);
    }
  }

  function handlePromptClick(event) {
    event.preventDefault();
    clearTimeout(self.ignoreTimeout);
    Cookies.remove('geoignored');
    geoLocateAndUpdate();
    ga('send', 'event', 'MyLocation', 'clicked');
  }

  function showPrompt() {
    $(self.settings.prompt).removeClass('is-hidden');
  }

  function hidePrompt() {
    $(self.settings.prompt).addClass('is-hidden');
  }

  function getClosestByLatLng(lat, lng) {
    var url = self.settings.getUrl + '?lat="' + lat + '"&lng="'+ lng +'"';
    return $.get(url)
      .then(function(data) {
        handleData(data);
        save(data.location.id, 30);
        Cookies.set('geolocated', 'true', { expires: 30, path: '/', domain: window.location.hostname });
        ga('send', 'event', 'MyLocation', 'geolocated', data.location.name);
      })
  }

  function geoLocateAndUpdate() {
    hidePrompt();
    output({
      location: { name: 'Locating...' },
      hideDetails: true,
    });
    navigator.geolocation.getCurrentPosition(
      function geoSuccess(position) {
        getClosestByLatLng(position.coords.latitude, position.coords.longitude);
      },
      function geoError(error) {
        switch (error.code) {
          case 1:
            ga('send', 'event', 'MyLocation', 'Error', 'denied');
            alert('Whoops! We can\'t find your closest store if you don\'t allow location permissions!');
            break;

          case 2:
            ga('send', 'event', 'MyLocation', 'Error', 'unable to find location');
            alert('Whoops! It doesn\'t look like we could find your location! Visit the location page to search for your ZIP code instead.');
            break;

          case 3:
            ga('send', 'event', 'MyLocation', 'Error', 'timeout');
            alert('Hmmm. This is taking a while. Visit the location page to search for your ZIP code instead.');
            break;

          default:
            break;
        }
        handleData(getCurrentData());
      }
    )
  }

  function setLocation(data) {
    window._currentLocation = data.location;
  }

  function handleData(data) {
    output(data);
    nearbyLocationCard(data);
    setLocation(data);
    orderButtonUpdate(data);
    save(data.location.id);
  }

  function getCurrentData() {
    return self.data;
  }

  function update(id, callback) {
    var url = self.settings.getUrl;
    if (!id && Cookies.get('location')) {
      url = self.settings.setUrl + Cookies.get('location');
    } else if (id) {
      url = self.settings.setUrl + id;
    }

    $.get(url, function(data) {
      handleData(data);
    })
    .then(function(){
      if (typeof callback !== 'undefined') {
        callback();
      }
    });
  }

  function init() {
    registerHelpers();
    update();
    initPrompt();
  }

  init();

  return {
    update: update,
    geoLocateAndUpdate: geoLocateAndUpdate,
    getCurrentData: getCurrentData,
  };
};
